import { atom } from "jotai";

import { selectedRoundAtom } from "../../stores";

export const setCourseLayoutIdOnRoundAtom = atom(
  null,
  (
    get,
    set,
    payload: {
      courseLayoutId: string;
    }
  ) => {
    const selectedRound = get(selectedRoundAtom);
    if (!selectedRound) {
      return;
    }

    set(selectedRoundAtom, {
      ...selectedRound,
      courseLayoutId: payload.courseLayoutId,
    });
  }
);
